import { render, staticRenderFns } from "./CheckMyClinicAssistantsDialog.vue?vue&type=template&id=10b9ff11&scoped=true"
import script from "./CheckMyClinicAssistantsDialog.vue?vue&type=script&lang=js"
export * from "./CheckMyClinicAssistantsDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckMyClinicAssistantsDialog.vue?vue&type=style&index=0&id=10b9ff11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9ff11",
  null
  
)

export default component.exports